import { styled, Table } from "@mui/material";

export const StyledTable = styled(Table)(({ theme }) => ({
    minWidth: 650,
    "& .MuiTableCell-root": {
      border: "0.5px solid #f2f6fa",
    },
  }));